// Minimal IndexedDB helper for caching the last 20 observations for offline viewing.
const DB_NAME = 'wildquest';
const STORE = 'observations';
const VERSION = 1;
const MAX_ENTRIES = 20;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const os = db.createObjectStore(STORE, { keyPath: 'observation_id' });
        os.createIndex('created_at', 'created_at');
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function cacheObservations(items) {
  if (!('indexedDB' in window) || !items?.length) return;
  try {
    const db = await openDb();
    const tx = db.transaction(STORE, 'readwrite');
    const os = tx.objectStore(STORE);
    // Add / replace latest
    items.slice(0, MAX_ENTRIES).forEach((it) => os.put(it));
    // Trim to MAX_ENTRIES by created_at desc
    await new Promise((res) => (tx.oncomplete = res));

    const tx2 = db.transaction(STORE, 'readwrite');
    const os2 = tx2.objectStore(STORE);
    const all = await new Promise((res) => {
      const r = os2.getAll();
      r.onsuccess = () => res(r.result || []);
      r.onerror = () => res([]);
    });
    if (all.length > MAX_ENTRIES) {
      const sorted = all.sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
      const drop = sorted.slice(MAX_ENTRIES);
      drop.forEach((d) => os2.delete(d.observation_id));
    }
  } catch (e) {
    // silent — offline cache is best-effort
  }
}

export async function getCachedObservations() {
  if (!('indexedDB' in window)) return [];
  try {
    const db = await openDb();
    return await new Promise((res) => {
      const r = db.transaction(STORE, 'readonly').objectStore(STORE).getAll();
      r.onsuccess = () => {
        const arr = r.result || [];
        arr.sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
        res(arr);
      };
      r.onerror = () => res([]);
    });
  } catch {
    return [];
  }
}
